<template>
  <div id="home">
    <div class="content">
      <el-form ref="form" v-loading="loading" label-width="100px">
        <el-form-item label="k" prop="patientName">
          <el-input-number v-model="webset.k" controls-position="right" :min="1" :max="10"></el-input-number>
        </el-form-item>
        <el-form-item label="" prop="patientName">
          <el-button type="primary" @click="saveInfo" style="background-color: #034844;border-color:#034844;padding:6px 20px;margin-top:20px;">Save</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { getAction, postAction } from '@/network/manage';
  export default {
    name: 'Setting',
    components: {
    },
    data() {
      return {
        loading:false,
        webset:{}
      }
    },
    computed: {

    },
    created(){
      this.loading = true
      getAction('/admin/webSet/query').then((res) => {
        if(res.success){
          this.webset = res.result
        }else{
          this.$message.error(res.message)
        }
      }).catch((err) => {
        this.$message.error(err.message)
      }).finally((res) => {
        this.loading = false
      });
    },
    methods:{
      saveInfo(){
        if(!this.webset.k){
          this.$message.error('k is required')
        }else{
          this.loading = true
          postAction('/admin/webSet/edit', this.webset).then((res) => {
            if(res.success){
              this.$message({
                message: 'save success!',
                type: 'success'
              });
            }else{
              this.$message.error(res.message)
            }
          }).catch((err) => {
            this.$message.error(err.message)
          }).finally((res) => {
            this.loading = false
          });
        }
      }
    }
  }
</script>

<style scoped>
  body{overflow-x: hidden;}
  *{font-size:16px;font-size:inherit;box-sizing: border-box;margin:0px;padding:0px;}
  #home{padding:20px;}
  .content{background-color: #ffffff;padding:30px 20px;border-radius: 12px;display: flex;align-items: center;}

  @media (max-width: 768px) {

  }
  @media screen and (min-width: 769px) and (max-width: 1024px) {

  }
</style>
